export default __webpack_public_path__ + "static/media/course-sample4.020cf594.png";